import Manager from "./manager"

export const goToTop = Manager.goToTop
export const configureAnchors = Manager.configure

export { default } from "./scrollable-anchor"



// WEBPACK FOOTER //
// ./src/containers/scrollable-anchor/index.js